export default __webpack_public_path__ + "assets/quickbooks_logo.33a2870a.png";